// Products count selector on header cart icon
export const getCartCountSelector = (state) =>
  state.cartItems?.productsCount?.defaultCount || 0;

// Total quantity count selector of each product
export const getCartTotalQuantitySelector = (state) =>
  state.cartItems?.productsCount?.totalQuantityCount || 0;

// Cart items selector
export const cartItemsDataSelector = (state) =>
  state.cartItems.items !== null && state.cartItems.items?.length > 0
    ? state.cartItems.items
    : [];

// Estimated tax selector
export const cartItemsEstimatedTax = (state) =>
  state.cartItems.getCartAPI?.estimatedtax
    ? state.cartItems.getCartAPI.estimatedtax
    : null;

// Freight recovery selector
export const cartItemsFreightRecovery = (state) =>
  state.cartItems.getCartAPI?.freightrecovery
    ? state.cartItems.getCartAPI.freightrecovery
    : 0;

// Order type selector
export const getCartOrderTypeSelector = (state) =>
  state.cartItems.getCartAPI?.orderType
    ? state.cartItems.getCartAPI.orderType
    : null;

// Total value selector
export const cartItemsTotalValueSelector = (state) =>
  state.cartItems.getCartAPI?.grandTotal
    ? state.cartItems.getCartAPI.grandTotal
    : null;

// Order details selector
export const orderDataSelector = (state) =>
  state.cartItems.orderDetails ? state.cartItems.orderDetails : null;

// Subtotal value selector
export const cartItemsSubTotalValueSelector = (state) =>
  state.cartItems.getCartAPI?.subtotal
    ? state.cartItems.getCartAPI.subtotal
    : null;

// BNC flag selector
export const getCartBNCFlagSelector = (state) =>
  state.cartItems.getCartAPI?.isBNCFlag
    ? state.cartItems.getCartAPI.isBNCFlag
    : false;

// Suggested order flag selector
export const getSuggestedOrderFlagSelector = (state) =>
  state.cartItems.getCartAPI?.isSuggestedOrder
    ? state.cartItems.getCartAPI.isSuggestedOrder
    : false;

// BNC Multi flag selector
export const getCartBNCMultiFlagSelector = (state) =>
  state.cartItems.getCartAPI?.isBNCMultiFlag
    ? state.cartItems.getCartAPI.isBNCMultiFlag
    : false;

// CNY Suggested Order flag selector
export const getCartCNYSuggestedOrderFlagSelector = (state) =>
  state.cartItems.getCartAPI?.isCNYSuggestedOrder
    ? state.cartItems.getCartAPI.isCNYSuggestedOrder
    : false;